import * as ui from 'datagrok-api/ui';
import * as DG from 'datagrok-api/dg';
export class HelmInputBase extends DG.JsInputBase {
}
export const HelmNotSupportedErrorType = 'HelmNotSupportedError';
export class HelmNotSupportedError extends Error {
    constructor(message) {
        super(message);
        this.type = HelmNotSupportedErrorType;
    }
}
export async function getHelmHelper() {
    const packageName = 'Helm';
    const funcList = DG.Func.find({ package: packageName, name: `getHelmHelper` });
    if (funcList.length === 0)
        throw new Error(`Package '${packageName}' must be installed for HelmHelper.`);
    const res = (await funcList[0].prepare().call()).getOutputParamValue();
    return res;
}
ui.input.helmAsync = async function (name, options) {
    return (await getHelmHelper()).createHelmInput(name, options);
};
/** Inputs logic */
export function getMonomerHandleArgs(a, name) {
    if (!a)
        throw new Error(`Argument 'a' of type Atom or HelmType is mandatory.`);
    let biotype;
    let elem;
    const aa = a;
    if (aa.T === 'ATOM') {
        // Legacy HelmAtom.biotype() returns the js-draw-lite HelmType union (which
        // still carries the `HELM_NUCLETIDE` typo); cast to the hwe-owned HelmType.
        biotype = aa.biotype();
        elem = aa.elem;
    }
    else {
        biotype = a;
        elem = name;
    }
    return [biotype, elem];
}
//# sourceMappingURL=helm-helper.js.map